import {Observable} from 'rxjs';
import {educatAPI, RestQueryParams} from 'educat-common-web';


export function getSubjectsAPI(authToken: string): Observable<any> {
    return educatAPI.get(
        'subjects',
        new RestQueryParams(),
        {
            Authorization: `Bearer ${authToken}`
        }
    );
}
